import React, { useState } from 'react';
import Calendar from 'react-calendar';

import 'react-calendar/dist/Calendar.css';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '30px'
}

const leftAlign = { textAlign: 'left' }

export function Appointments(){
  const [dates, updateDates] = useState([]);
  
  return (
    <div>
      <div>
        <h1>Email to Request an Appointment</h1>
        <h3>mcnymassage@gmail.com</h3>
        <h1>What to Expect</h1>
        <p style={leftAlign}>
          Michael Takes Care of Everything! All that you need for your session is space for 
          the massage table. From linen to lotion, Michael has it covered. It will take about 
          5-10 minutes to set up the equipment. Once setup, Michael will step out of the room to 
          allow you privacy to disrobe and slide under the sheet. The choice of music is yours 
          and the duration of the treatment is for the amount of time purchased. 
          At the end of your session, Michael will again step out of the room in order for you to 
          get up from the table and get dressed. Your safety and privacy are my top priority. 
          The removal of equipment and departure takes approximately 10 minutes. 
          It's super easy and your space will look like Michael was never there as to not add any stress to 
          your household. 
        </p>
        <p style={leftAlign}>
          Michael is fully licensed and insured in the state of New York. 
          I am fully vaccinated and follow a rigorous cleaning and sanitization routine 
          with all equipment. 
          Your appointment must be confirmed 24 hours in advance. 
          Your Safety and Privacy are always the top priority. 
          So relax......Michael's got your back.
        </p>
      </div>

      {/* <div style={containerStyle}>
        <div style={{ width: '300px', marginLeft: 'auto', marginRight: 'auto' }}>
          <Calendar
            defaultActiveStartDate={new Date()} 
            onChange={ date => {
              updateDates(prevDates => [ ...prevDates, date ])
            }}
          />
        </div>
        <div>
          { dates.map((date, i) => <div key={`day-${i}`}>{date.toDateString()}</div>) }
        </div>
      </div> */}
    </div>
  );
}
